import React from 'react';
import { X, LayoutDashboard, TrendingUp, Target, DollarSign, BarChart3, ExternalLink } from 'lucide-react';

export default function FaturamentoTotal({ data, onClose, onOpenDashboard }) {
  const formatBRL = (valor) => Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
      <div className="w-full max-w-3xl overflow-hidden rounded-lg border border-gray-800 bg-[#0d1117] shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-800 bg-[#161b22] p-4">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-green-400">
            <LayoutDashboard size={18} />
            <span>Detalhamento de Faturamento</span>
          </div>
          <button type="button" onClick={onClose} className="text-gray-500 transition-colors hover:text-white" aria-label="Fechar">
            <X size={20} />
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4 p-6 md:grid-cols-2">
          <Indicador titulo="Faturamento do dia" valor={formatBRL(data?.valor_totalDia ?? data?.Valor_TotalDia)} icone={DollarSign} cor="text-white" />
          <Indicador titulo="Total realizado (mês)" valor={formatBRL(data?.valor_Total ?? data?.valor_total)} icone={TrendingUp} cor="text-gray-300" />
          <Indicador titulo="Maior faturamento (mês)" valor={formatBRL(data?.valor_total_maior)} icone={TrendingUp} cor="text-green-400" />
          <Indicador titulo="Devoluções do mês" valor={formatBRL(data?.valor_devolucoesMes)} icone={BarChart3} cor="text-red-400" />

          <div className="md:col-span-2">
            <button
              type="button"
              onClick={onOpenDashboard}
              className="group flex w-full items-center justify-center gap-2 rounded-lg border border-blue-500/30 bg-blue-600/10 py-3 text-blue-400 transition-all hover:bg-blue-600/20"
            >
              <BarChart3 size={16} className="transition-transform group-hover:scale-110" />
              <span className="text-[10px] font-black uppercase tracking-[0.2em]">Abrir painel completo</span>
              <ExternalLink size={14} className="opacity-50" />
            </button>
          </div>

          <div className="md:col-span-2 flex items-center gap-4 rounded border border-green-900/30 bg-[#161b22] p-4">
            <div className="rounded-full bg-green-500/10 p-3 text-green-400"><Target size={24} /></div>
            <div>
              <p className="text-[10px] font-bold uppercase text-gray-400">Status Comercial</p>
              <p className="text-xs italic text-gray-300">
                {Number(data?.percentualMeta) >= 100 ? 'Meta mensal atingida com sucesso.' : 'Em andamento para atingir a meta projetada.'}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 bg-[#0d1117] p-4 text-right">
          <button type="button" onClick={onClose} className="rounded bg-gray-800 px-8 py-2 text-[10px] font-black uppercase tracking-widest text-white shadow-lg transition-all hover:bg-gray-700">
            Fechar Janela
          </button>
        </div>
      </div>
    </div>
  );
}

function Indicador({ titulo, valor, icone: Icone, cor }) {
  return (
    <div className="rounded border border-gray-800 bg-[#161b22] p-4">
      <div className="mb-2 flex justify-between"><p className="text-[10px] font-bold uppercase italic tracking-tighter text-gray-500">{titulo}</p><Icone size={14} className="text-gray-600" /></div>
      <p className={`font-mono text-2xl font-bold ${cor}`}>{valor}</p>
    </div>
  );
}
